import _ from 'lodash';

const ADMIN_ROLE = 'admin';
const AGENCY_ROLE = 'agency';
const PARTNER_ROLE = 'partner';
const SALESMAN_ROLE = 'salesman';
const MARKETER_ROLE = 'marketer';

export default class UserManager {

  static getInstance () {
    if (!UserManager.sharedInstance) {
      const sharedInstance = new UserManager();
      UserManager.sharedInstance = sharedInstance;
    }
    return UserManager.sharedInstance;
  }

  initialize = (user) => {
    this._user = user;
  };

  updateUser = (user) => {
    this._user = user;
  };

  isSignedIn () {
    if (_.isEmpty(this._user)) {
      return;
    }
    const {credential, info} = this._user;
    return !_.isEmpty(credential)
      && !_.isEmpty(credential.username)
      && !_.isEmpty(credential.password)
      && !_.isEmpty(info);
  }

  isAdmin = () => {
    return this._user && this._user.info && this._user.info.role === ADMIN_ROLE;
  };

  isAgency = (user) => {
    return this._user && this._user.info && this._user.info.role ===
      AGENCY_ROLE;
  };

  isPartner = () => {
    return this._user && this._user.info && this._user.info.role ===
      PARTNER_ROLE;
  };

  isSeller = () => {
    return this._user && this._user.info
      && (this._user.info.role === AGENCY_ROLE
        || this._user.info.role === PARTNER_ROLE);
  };

  isSalesman = () => {
    return this._user && this._user.info && this._user.info.role ===
      SALESMAN_ROLE;
  };

  isMarketer = () => {
    return this._user && this._user.info && this._user.info.role ===
      MARKETER_ROLE;
  };
}


// WEBPACK FOOTER //
// ./src/utils/UserManager.js